import React from "react";
import ReactECharts from "echarts-for-react";
import "./PreCheckContent.scss";

/**
 * 檢測前畫面組件
 *
 * 顯示在使用者登入但尚未完成檢測時
 * 包含：
 * - 雷達圖（顯示平均值/參與度）
 * - 落後產業百分比文字
 * - 說明文案
 */
const PreCheckContent = () => {
  // 雷達圖配置（固定的平均值數據）- 與 PostCheckContent 一致，只移除客戶名稱
  const radarOption = {
    grid: {
      left: "10%",
      right: "10%",
      top: "10%",
      bottom: "10%",
      containLabel: true,
    },
    legend: {
      data: ["平均值"], // 只顯示平均值，移除客戶名稱
      top: "0", // 設定在頂部
      left: "center", // 設定水平居中
    },
    tooltip: {
      trigger: "item",
    },
    radar: {
      center: ["50%", "52%"],
      radius: "60%",
      indicator: [
        { name: "參與度", max: 5 },
        { name: "購買率", max: 5 },
        { name: "新客率", max: 5 },
        { name: "購物車率", max: 5 },
        { name: "跳出率", max: 5 },
        { name: "初次購買率", max: 5 },
      ],
      axisName: {
        color: "#000",
        fontSize: 14,
        // fontWeight: "bold",
      },
    },
    series: [
      {
        name: "指標比較",
        type: "radar",
        data: [
          {
            value: [3, 3, 3, 3, 3, 3],
            name: "平均值",
            itemStyle: {
              color: "#90c21c",
            },
            lineStyle: {
              color: "#90c21c",
              width: 2,
              type: "dashed",
            },
            areaStyle: {
              color: "rgba(144, 194, 28, 0.15)", // 綠色半透明
            },
          },
        ],
      },
    ],
  };

  return (
    <div className="pre-check-content">
      {/* 雷達圖 - 結構與 PostCheckContent 一致 */}
      <div className="radar-chart-wrapper section">
        <ReactECharts
          className="radar-chart"
          style={{ height: "400px", width: "100%" }}
          option={radarOption}
        />
      </div>

      {/* 落後產業資訊 - 結構與 PostCheckContent 的 new-score section 一致 */}
      {/* <div className="new-score section">
        <div className="new-score-title">
          落後產業 <span className="highlight">XX%</span>
        </div>
      </div> */}

      {/* 說明文案 */}
      <div className="description">
        <p>
          透過自動化檢測、量化評分與系統化診斷，將洞察轉化為可落地的改善計畫與追蹤機制，讓決策更即時、流程更可靠、成效可持續。
        </p>
      </div>
    </div>
  );
};

export default PreCheckContent;
